//@ts-nocheck
import React from "react";
// import MarketplaceThemeProvider from "containers/MarketplaceThemeProvider";
import Typography from "component/commonComponents/Typography";
import Box from "component/layoutComponents/Box";
import { StyledCalendar } from "./Calendar.style";
import moment from 'moment';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const CalendarComponent = (props: any) => {
    const { userInfor, locale, isOffboarding, isLastAccess } = props;
    const formatStartDate = moment(isOffboarding ? !isLastAccess ? userInfor?.last_working_date : userInfor?.last_access_date :userInfor?.start_date, moment.ISO_8601).toDate();

  return (
      <>
        {!isOffboarding && <Typography marginBottom="12px" fontWeight="600" fontSize="12px">{locale?.OnboardingDuration}</Typography>}
        <Box 
          borderRadius="8px" 
          background="#DBD9FF"
          padding="12px"
          >
          <StyledCalendar
            calendarType='US'
            minDate={new Date()}
            maxDate={formatStartDate}
            defaultView="month"
            maxDetail="month"
            minDetail="month"
            value={[new Date(),formatStartDate]}
            returnValue="range"
            formatShortWeekday={(locale, date) => ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()]}
            prevLabel={<NavigateBeforeIcon/>}
            prevAriaLabel="Previous"
            nextLabel={<NavigateNextIcon/>}
            nextAriaLabel="Next"
            prev2Label={null}
            next2Label={null}
            isOffboarding={isOffboarding}
          />
        </Box>
      </>
  )
};

export default CalendarComponent;